module.exports = __webpack_public_path__ + "img/143.c54f0856.jpg";